import { FC } from "react";
import useSettings from "../../../hooks/useSettings";
import { Layouts } from "./index";
import SuspenseWithLoading from "../SuspenseWithLoading";

const Layout: FC = (props) => {
  const { settings } = useSettings();
  const Layout = (Layouts as any)[settings.activeLayout];

  if (!Layout) {
    return null;
  }

  return (
    <SuspenseWithLoading>
      <Layout {...props} />
    </SuspenseWithLoading>
  );
};

export default Layout;